import React from 'react';
import { FileText } from 'lucide-react';
import Header from '@/components/layout/Header';
import FooterNew from '@/components/layout/FooterNew';

const TermsPage = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />

      <main className="flex-1">
        <section className="bg-gradient-to-br from-red-50 to-cyan-50 py-12">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto text-center">
              <FileText className="w-12 h-12 text-red-600 mx-auto mb-4" />
              <h1 className="text-4xl font-bold gradient-text mb-4">Conditions d'utilisation</h1>
              <p className="text-gray-600">Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}</p>
            </div>
          </div>
        </section>

        <section className="py-12">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto prose prose-lg">
              <h2>1. Acceptation</h2>
              <p>
                En utilisant Coli Noki, vous acceptez ces conditions ainsi que la politique de confidentialité.
              </p>

              <h2>2. Rôles et responsabilités</h2>
              <h3>2.1 Vendeur</h3>
              <ul>
                <li>Fournir des informations exactes sur les colis et adresses</li>
                <li>Assurer le paiement avant validation de la livraison</li>
                <li>Respecter les produits autorisés et les obligations légales</li>
              </ul>

              <h3>2.2 Livreur</h3>
              <ul>
                <li>Exécuter les missions selon les statuts et procédures de preuve</li>
                <li>Utiliser OTP et photo lorsque requis</li>
                <li>Déclarer sans délai les incidents (client absent, échec, report)</li>
              </ul>

              <h3>2.3 Plateforme</h3>
              <ul>
                <li>Fournir une infrastructure de suivi et de paiement raisonnablement disponible</li>
                <li>Maintenir des contrôles de sécurité et de modération</li>
              </ul>

              <h2>3. Règles tarifaires et plans</h2>
              <ul>
                <li>Plan Gratuit : accès de base à la plateforme</li>
                <li>Coli Noki Pro : options premium selon entitlement actif</li>
                <li>Le service de livraison express est une option de livraison distincte</li>
              </ul>

              <h2>4. Règles livraison express et assurance</h2>
              <ul>
                <li>Express : supplément tarifaire (ex. : +75 % transport) selon configuration active</li>
                <li>Assurance : supplément calculé sur la valeur déclarée du colis</li>
                <li>Ces options peuvent être réservées aux vendeurs Pro</li>
              </ul>

              <h2>5. Portefeuille et paiements</h2>
              <ul>
                <li>Le portefeuille permet crédit, débit et suivi transactionnel</li>
                <li>Les recharges et ajustements suivent les règles de contrôle admin</li>
                <li>Aucun solde négatif n'est autorisé</li>
              </ul>

              <h2>6. Affiliation</h2>
              <ul>
                <li>Les commissions sont générées selon les règles métier actives</li>
                <li>Le paiement des gains dépend des validations et statuts admin</li>
              </ul>

              <h2>7. Limitation de responsabilité</h2>
              <p>
                Coli Noki ne peut être tenu responsable des cas de force majeure, des informations erronées fournies par un utilisateur ou du non-respect des procédures par un acteur tiers.
              </p>

              <h2>8. Contact légal</h2>
              <p>
                Pour toute question juridique : legal@colinoki.com
              </p>
              <p>
                Pour les détails de traitement des données, consultez la <a href="/privacy" className="text-red-600 hover:underline">politique de confidentialité</a>.
                Pour les offres, consultez la <a href="/pricing" className="text-red-600 hover:underline">page tarifs</a>.
              </p>
            </div>
          </div>
        </section>
      </main>

      <FooterNew />
    </div>
  );
};

export default TermsPage;
